// Unknown route inside the app (old bookmark of a removed page, typo).
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Compass } from 'lucide-react';
import { EmptyState } from '../design/ui';

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="u-page">
      <div className="u-well">
        <div className="u-card">
          <EmptyState
            icon={Compass}
            title={t('publicUi.notFoundTitle', 'Cette page n’existe pas ou n’existe plus')}
            action={(
              <button type="button" className="u-btn u-btn--primary" onClick={() => navigate('/dashboard')}>
                {t('publicUi.notFoundAction', 'Aller au tableau de bord')}
              </button>
            )}
          >
            {t('publicUi.notFoundText', 'Le lien est peut-être ancien. Le menu de gauche mène à toutes les pages.')}
          </EmptyState>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
